"use client"

import "./App.css"
import Header from "./components/Header"
import QRCodeGenerator from "./components/QRCodeGenerator"
import Footer from "./components/Footer"

function App() {
  return (
    <div className="app">
      <Header />
      <main className="app-content">
        <QRCodeGenerator />
      </main>
      <Footer />
    </div>
  )
}

export default App
